class DeferredScript extends HTMLElement {
  constructor() {
    super()

    this.handleScroll = this.handleScroll.bind(this)

    document.addEventListener('scroll', this.handleScroll, {
      passive: true,
    })
  }

  handleScroll(e) {
    if (window.scrollY > 200) {
      this.addURLToDOM({
        url: this.getAttribute('src'),
      })
      document.removeEventListener('scroll', this.handleScroll)
    }
  }

  addURLToDOM({ url: src, integrity = false }) {
    if (~src.indexOf('.css')) {
      var s = document.createElement('link')
      s.rel = 'stylesheet'
      s.href = src
      var x = document.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
    } else {
      var s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = src
      if (integrity) {
        s.integrity = integrity
        s.crossOrigin = 'anonymous'
        s.cors = true
      }
      var x = document.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
    }
  }
}

customElements.define('deferred-script', DeferredScript)
